import { formatDate, formatDateUtil } from "@utils/date.util";
import { PRIMARY_KEY } from "@constants/app.constants";

const tableTitle = "Site Settings List";
const keyColumn = PRIMARY_KEY;
const menuUrl = "settings/site-settings";
const tableColumn = [
  {
    id: "header_logo",
    numeric: false,
    disablePadding: false,
    label: "Header Logo",
    formatData: (data) => (
      <img
        src={data}
        alt="Image"
        style={{ width: "50px", height: "50px" }}
      />
    ),
  },
  {
    id: "footer_logo",
    numeric: false,
    disablePadding: false,
    label: "Footer Logo",
    formatData: (data) => (
      <img
        src={data}
        alt="Image"
        style={{ width: "50px", height: "50px" }}
      />
    ),
  },
  {
    id: "contact_number",
    numeric: false,
    disablePadding: false,
    label: "Mobile",
  },
  {
    id: "contact_email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "address",
    numeric: false,
    disablePadding: false,
    label: "Address",
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDate,
  },
];
const breadCrumbs = [{ name: "Site Settings", menu_url: "/settings/site-settings" }];


export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
};
